import { useQuery } from '@tanstack/react-query';

import { venueListOffersApi } from '../../api/offers/venueListOffersApi';
import { OfferStatus } from '../../graphql/API';
import { useAppSelector } from '../../redux/hooks';

/**
 * Returns whether the current venue already has at least one active offer/product
 * with a TikTok requirement. Used to gate the dashboard TikTok banner and to
 * switch the offers/products grid promo card between first-time and follow-up copy.
 */
export const useHasActiveTikTokOffer = () => {
  const venue = useAppSelector((state) => state.venue.value);

  const { data: hasActiveTikTokOffer, isLoading } = useQuery({
    queryKey: ['has-active-tiktok-offer', venue?.id],
    queryFn: async () => {
      const offers = await venueListOffersApi({
        venueID: String(venue?.id),
        status: OfferStatus.active,
        limit: 200,
      });

      return offers.some((offer) => offer.postOnTikTokVideo === true);
    },
    enabled: Boolean(venue?.id),
    refetchOnWindowFocus: false,
  });

  return { hasActiveTikTokOffer, isLoading };
};

export default useHasActiveTikTokOffer;
